import { Pipe, PipeTransform } from '@angular/core';
import { JumpstarterFavorite } from '../../domains/users/jumpstarter-favorites/jumpstarter-favorite.model';

@Pipe({ name: 'jumpstarterFavoriteIsStatus' })
export class JumpstarterFavoriteIsStatusPipe implements PipeTransform {
  transform(favorite?: JumpstarterFavorite, ...statuses: string[]): boolean {
    return !!favorite && statuses.some(status => favorite.addToTeamStatus === status);
  }
}
